module.exports = __webpack_public_path__ + "media/images/arrow-left-479bc242a5d2ca1b89d5523d704ae3bb.svg";